import type { ReactNode } from 'react'
import { Checkbox, type CheckboxProps } from '@/components/Checkbox'
import { Help } from '@/components/Form'
import styles from './CheckboxInput.module.css'

export interface CheckboxInputProps extends Omit<
  CheckboxProps,
  'checked' | 'onChange'
> {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  help?: ReactNode
  error?: string
}

/**
 * A checkbox with a label, help text and an error.
 */
export function CheckboxInput({
  checked,
  onChange,
  error,
  help,
  label,
  ...props
}: CheckboxInputProps) {
  return (
    <div className={styles.root}>
      <Checkbox checked={checked} onChange={onChange} {...props} />
      <div className={styles.content}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- mouse shortcut; the checkbox is the keyboard target */}
        <label
          title={label}
          className={styles.label}
          onClick={() => onChange(!checked)}
        >
          {label}
        </label>
        <Help error={error} help={help} />
      </div>
    </div>
  )
}
